import { Fragment, PureComponent } from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import ErrorMessage from 'components/Shared/ErrorMessage';
import formatDistance from 'date-fns/formatDistance';
import locale from 'date-fns/locale/pt-BR';
import { IStyledProps, WithStyles } from 'decorators/withStyles';
import { dateFormat } from 'formatters/date';
import ISync, { IDashboardSync } from 'interfaces/models/sync';
import CloseCircleIcon from 'mdi-react/CloseCircleIcon';
import UpdateIcon from 'mdi-react/UpdateIcon';
import bindComponent from 'rxjs-operators/bindComponent';
import dashboardService from 'services/dashbord';

interface IState {
  sync?: IDashboardSync;
  loading: boolean;
  error?: any;
}

@WithStyles(theme => ({
  wrapper: {
    height: '100%'
  },
  icon: {
    margin: '0 10px 0 0',
    verticalAlign: 'text-top'
  },
  iconError: {
    color: theme.palette.error.main
  },
  text: {
    lineHeight: 'normal'
  }
}))
export default class Sync extends PureComponent<IStyledProps, IState> {
  constructor(props: IStyledProps) {
    super(props);
    this.state = { loading: true };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.loadData();
  }

  loadData = () => {
    this.setState({ loading: true, error: null });

    dashboardService
      .sync()
      .pipe(bindComponent(this))
      .subscribe({
        next: sync => this.setState({ loading: false, sync }),
        error: error => this.setState({ loading: false, error })
      });
  };

  render() {
    const { loading, error, sync } = this.state;
    const { classes } = this.props;

    return (
      <Card className={classes.wrapper}>
        {loading && <LinearProgress variant='indeterminate' />}

        {!!error && (
          <CardContent>
            <ErrorMessage error={error} tryAgain={this.loadData} />
          </CardContent>
        )}

        {!error && (
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <SyncData title='Sincronização Viva Real' sync={(sync || ({} as any)).vivareal} classes={classes} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <SyncData title='Sincronização Olx' sync={(sync || ({} as any)).olx} classes={classes} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <SyncData title='Sincronização Imóvel Web' sync={(sync || ({} as any)).imovelweb} classes={classes} />
              </Grid>
            </Grid>
          </CardContent>
        )}
      </Card>
    );
  }
}

function SyncData({ title, sync, classes }: { title: string; sync: ISync; classes: any }) {
  return (
    <Fragment>
      <Typography color='textSecondary' gutterBottom>
        {title}
      </Typography>

      {!sync && (
        <Typography variant='h6' className={classes.text}>
          <UpdateIcon className={classes.icon} />
          Nunca
        </Typography>
      )}

      {sync && (
        <Fragment>
          <Typography variant='subtitle1' className={classes.text}>
            {sync.success ? (
              <UpdateIcon className={classes.icon} />
            ) : (
              <CloseCircleIcon className={`${classes.icon} ${classes.iconError}`} />
            )}
            {formatDistance(sync.createdDate, new Date(), { locale })}
          </Typography>
          <Typography variant='caption'>
            <span>{sync.success ? 'Sucesso  • ' : 'Falha • '}</span>
            {dateFormat(sync.createdDate, "dd/MM/yy 'às' HH:mm")}
          </Typography>
        </Fragment>
      )}
    </Fragment>
  );
}
